import { Link } from "react-router-dom";
function Navbar() {
  const links = {
    textDecoration: "none",
  };

  return (
    <nav class="navbar navbar-expand-lg navbar-light bg-white py-3">
      <div class="container px-5">
        <Link to="/" style={links}>
          <a class="navbar-brand">
            <span class="fw-bolder text-primary">Furqaan Mujtahid</span>
          </a>
        </Link>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0 small fw-bolder">
            <Link to="/" style={links}>
              <li class="nav-item">
                <a class="nav-link" href="index.html">
                  Home
                </a>
              </li>
            </Link>

            <Link to="/Resume" style={links}>
              <li class="nav-item">
                <a class="nav-link" href="resume.html">
                  Resume
                </a>
              </li>
            </Link>

            <Link to="/Projects" style={links}>
              <li class="nav-item">
                <a class="nav-link" href="projects.html">
                  Projects
                </a>
              </li>
            </Link>

            <Link to="/Contact" style={links}>
              <li class="nav-item">
                <a class="nav-link" href="contact.html">
                  Contact
                </a>
              </li>
            </Link>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
